import {Link} from '@chakra-ui/react'
import React from 'react'
import {v4 as uuidv4} from 'uuid'

export const LinkRenderer = (node, children) => (
    <Link
        key={uuidv4()}
        isNested={!!(node?.data?.uri && node?.data?.uri === '#')}
        href={node.data?.uri}
        textDecoration="underline"
        isExternal
    >
        {children}
    </Link>
)
